var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.from === 'dongyu' ? 'app-dongyu' : 'app-xinghe', { 'app-pc-home': _vm.showPcHome }],attrs:{"id":"app"}},[(_vm.showPcHome)?_c('PcHome'):[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }